import { EVoyageTile } from './voyageTileData'

export interface ISpecialLayerData {
  t: EVoyageTile
  s?: number
  c?: number
  text?: string
}

export const specialLayerData_floor: ISpecialLayerData[] = [
  {
    t: EVoyageTile.SquareBottom,
  },
  {
    t: EVoyageTile.FakeBottom,
  },
  {
    t: EVoyageTile.Null2,
  },
  {
    t: EVoyageTile.Floor,
  },
]

export const specialLayerData_decor: ISpecialLayerData[] = [
  {
    t: EVoyageTile.Null2,
  },
  {
    t: EVoyageTile.Floor,
  },
  {
    t: EVoyageTile.Door,
    s: 0,
    c: 2,
  },
  {
    t: EVoyageTile.Door,
    s: 1,
    c: 2,
  },
  {
    t: EVoyageTile.Table,
  },
  {
    t: EVoyageTile.Chair,
  },
  {
    t: EVoyageTile.Fence,
    s: 0,
    c: 2,
  },
  {
    t: EVoyageTile.Fence,
    s: 1,
    c: 2,
  },
  {
    t: EVoyageTile.Fence,
    s: 2,
    c: 2,
  },
  {
    t: EVoyageTile.Fence,
    s: 3,
    c: 2,
  },
  {
    t: EVoyageTile.Fence,
    s: 5,
    c: 2,
  },
  {
    t: EVoyageTile.Fence,
    s: 4,
    c: 2,
  },
]

export const specialLayerData_hull: ISpecialLayerData[] = [
  {
    t: EVoyageTile.Null2,
  },
  {
    t: EVoyageTile.Floor,
  },
  {
    t: EVoyageTile.Square,

    c: 1,
  },
  {
    t: EVoyageTile.Triangle,
    s: 0,
    c: 2,
  },
  {
    t: EVoyageTile.Triangle,
    s: 1,
    c: 2,
  },
  {
    t: EVoyageTile.Triangle,
    s: 2,
    c: 2,
  },
  {
    t: EVoyageTile.Triangle,
    s: 3,
    c: 2,
  },
]

export const specialLayerData_sys: ISpecialLayerData[] = [
  {
    t: EVoyageTile.Null3,
  },
  {
    t: EVoyageTile.System,
    text: 'bed',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-empty',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-br',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-ext',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-wr',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-suit',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-mop',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-med',
  },
  {
    t: EVoyageTile.System,
    text: 'rack-torp',
  },

  {
    t: EVoyageTile.System,
    text: 'torpedo-',
  },
  {
    t: EVoyageTile.System,
    text: 'loader-',
  },
  {
    t: EVoyageTile.System,
    text: 'laser-',
  },
  {
    t: EVoyageTile.System,
    text: 'fp-',
  },
  {
    t: EVoyageTile.System,
    text: 'coffee',
  },
  {
    t: EVoyageTile.System,
    text: 'hyper',
  },
  {
    t: EVoyageTile.System,
    text: 'coms',
  },
  {
    t: EVoyageTile.System,
    text: 'sensor-internal',
  },
  {
    t: EVoyageTile.System,
    text: 'sensor-external',
  },
  {
    t: EVoyageTile.System,
    text: 'nav',
  },
  {
    t: EVoyageTile.System,
    text: 'captain',
  },
  {
    t: EVoyageTile.System,
    text: 'cargo',
  },
  {
    t: EVoyageTile.System,
    text: 'tele',
  },

  {
    t: EVoyageTile.System,
    text: 'ejector-',
  },
  {
    t: EVoyageTile.System,
    text: 'ejectrol-',
  },
  {
    t: EVoyageTile.System,
    text: 'ejp-',
  },

  {
    t: EVoyageTile.System,
    text: 'med-',
  },
  {
    t: EVoyageTile.MedPad,
    text: 'pad-',
  },
  {
    t: EVoyageTile.System,
    text: 'life-support',
  },
  {
    t: EVoyageTile.System,
    text: 'reactor',
  },
]
